import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/bh/bahrain-back.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Bahrain">
                <h1>
                  Leading Mobile App Development Company in Bahrain
                </h1>
              </div>
              <p className="main_para">
                Initiate your journey towards progressive growth with our mobile
                app development company. We specialize in multiple technologies
                leveraging the best resources in the IT industry. Facilitating
                numerous business ideas with our app solutions, we have enabled
                them to streamline their operations, automate complex tasks, and
                increase the ROI by 55% as a result.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
              <Link
                to="/app-cost-calculator"
                className="border_btn dark_btn ms-md-2 ms-0"
                aria-label="TekRevol Contact"
              >
                App Cost Calculator
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            {/* <LazyLoadImage
              src={Img}
              effect="blur"
              alt="mobile app development company in bahrain"
              className="img-fluid"
            /> */}

            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
